import { type FC } from 'react';

import { AdfoxCarouselBannerWrapper, AdfoxCarouselWrapper, Scroller } from 'shared/components/AdfoxCarousel';
import { AdBannerWithPostViewAnalytics } from 'shared/components/AdBannerWithPostViewAnalytics';
import { AdfoxBannerContextProvider } from 'shared/components/AdfoxBannerContext';
import { type InitialAdfoxAnalyticsPayload } from 'shared/types/analytics';
import { type TAdBannerMicrofrontendParameters } from 'shared/types/microfrontendParameters';
import { type TBannerEvents } from 'shared/types/events';

import { useBannerCarousel } from './hooks';

type TBannerCarouselContainerProps = {
  parameters: TAdBannerMicrofrontendParameters;
  placeId: string;
  dispatchLifecycleEvent(event: TBannerEvents): void;
};

export const BannerCarouselContainer: FC<TBannerCarouselContainerProps> = ({
  parameters,
  placeId,
  dispatchLifecycleEvent,
}) => {
  const { puids, sizes, pParams, regionId, position, place, isSp, tgbNativedescGeneralDesign } = parameters;

  const { allFailed, bannerEmitters, visibleBanners } = useBannerCarousel({ dispatchLifecycleEvent, placeId });

  if (allFailed) {
    return null;
  }

  return (
    <AdfoxCarouselWrapper>
      <Scroller>
        {visibleBanners.map(({ position: galleryPosition }) => {
          const analyticsData: InitialAdfoxAnalyticsPayload = {
            galleryPosition,
            isSp,
            place,
            position,
          };

          return (
            <AdfoxCarouselBannerWrapper fullWidth={visibleBanners.length === 1} key={galleryPosition}>
              <AdfoxBannerContextProvider
                placeId={placeId}
                eventEmitter={bannerEmitters[galleryPosition - 1]}
                puids={puids}
                sizes={sizes}
                pParams={pParams}
                regionId={regionId}
                analyticsData={analyticsData}
                tgbNativedescGeneralDesign={tgbNativedescGeneralDesign}
              >
                <AdBannerWithPostViewAnalytics />
              </AdfoxBannerContextProvider>
            </AdfoxCarouselBannerWrapper>
          );
        })}
      </Scroller>
    </AdfoxCarouselWrapper>
  );
};
